export default __webpack_public_path__ + "static/cs-screen-68eb0e237c063b859733e0f1eeac03c3.png";